import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of, from } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';

import { LobbyComponent } from '../pages/lobby/lobby.component'; // ajusta
import { ConfirmDialogLobbyComponent } from '../pages/lobby/confirm-dialog-lobby/confirm-dialog-lobby.component'; // ajusta
import { ZoomService } from 'src/app/services/zoom.service';

@Injectable({ providedIn: 'root' })
export class CanDeactivateLobbyGuard implements CanDeactivate<LobbyComponent> {
  constructor(
    private dialog: MatDialog,
    private zoomService: ZoomService
  ) {}

  canDeactivate(
    component: LobbyComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    // ✅ 1) Si es navegación automática a la videoconsulta, NO bloquear
    if (nextState?.url?.includes('/mivideoconsulta/')) return true;

    // ✅ 2) Si no tenemos id_consulta, no bloquees (evitas edge cases)
    const id_consulta = component?.parametros_url?.id_consulta;
    if (!id_consulta) return true;

    // ✅ 3) Abrir modal
    const dialogRef = this.dialog.open(ConfirmDialogLobbyComponent, {
      disableClose: true,
      autoFocus: false,
      width: '520px'
    });

    return dialogRef.afterClosed().pipe(
      take(1),
      switchMap((confirmed: any) => {
        if (confirmed !== true) return of(false);

        // ✅ 4) Cortar el while del lobby antes de salir
        component.entro_anfitrion = true;

        // ✅ 5) Avisar al backend que salió (method: 'out')
        const params = { id_consulta, method: 'out' };

        // postUpdateStartLobby devuelve Promise, lo convertimos a Observable
        return from(this.zoomService.postUpdateStartLobby(params)).pipe(
          map(() => true),
          catchError((err) => {
            console.log('Error postUpdateStartLobby OUT:', err);
            // si falla, decide si bloqueas o permites:
            // recomiendo bloquear para asegurar registro de salida:
            component.entro_anfitrion = false; // si quieres reactivar el loop
            return of(false);
          })
        );
      }),
      catchError(() => of(false))
    );
  }
}
